// Demo mode: shows sales-walkthrough helpers ("Seed demo data", diagnostics
// panels) that real customers must never see.
//
// Turn it on for a demo by opening any app URL with `?demo=1` (it sticks in
// localStorage for that browser) or by signing in with an email whose local
// part contains "+demo". Turn it off with `?demo=0`.

const KEY = "vg-demo";

function syncFromUrl(): void {
  try {
    const v = new URLSearchParams(window.location.search).get("demo");
    if (v === "1") localStorage.setItem(KEY, "1");
    if (v === "0") localStorage.removeItem(KEY);
  } catch {
    /* private mode / SSR */
  }
}

export function isDemoMode(): boolean {
  syncFromUrl();
  try {
    if (localStorage.getItem(KEY) === "1") return true;
    const raw = localStorage.getItem("scholarpetition.session");
    if (raw) {
      const parsed = JSON.parse(raw) || {};
      const email: string = parsed.userEmail ?? parsed.email ?? "";
      if (/\+demo/i.test(email.split("@")[0] ?? "")) return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}
